import { IWorkspace } from 'src/types';
import reducerConstants from '../reducers/constant';

export const selectWorkspace = (workspace: IWorkspace) => {
  return {
    type: reducerConstants.SELECT_WORKSPACE,
    payload: workspace,
  };
};
